import React from "react";

import { IStatMetricProps, StatMetric } from "./StatMetric";

interface IProps {
  metrics: IStatMetricProps[];
}

const gridClassForCount = (count: number): string => {
  if (count <= 1) {
    return "grid-cols-1";
  }
  if (count === 2) {
    return "grid-cols-2";
  }
  if (count === 3) {
    return "grid-cols-3";
  }
  return "grid-cols-2";
};

export const MetricGrid = (props: IProps) => {
  const count = props.metrics.length;
  const size = count >= 4 ? "compact" : "default";

  return (
    <div
      className={`grid ${gridClassForCount(count)} gap-y-4 gap-x-2 w-full h-full content-center items-center`}
    >
      {props.metrics.map((metric) => (
        <StatMetric key={metric.label} {...metric} size={size} />
      ))}
    </div>
  );
};
